export interface Invoice {
    id: string;
    buyerName: string;
    supplierName: string;
    invoiceNumber: string;
    invoiceDate: Date;
    dueDate: Date;
    adjustDueDate: Date;
    status: string;
    fundsSent: Date;
    postDate: Date;
    paymentDate: Date;
    paymentId: string;
    paymentAmount: string;
    fboStatus: string;
    collectionUpdated: Date;
    collectionCreated: Date;
}

export type StatusInvoiceEnum = 'Paid' | 'Early Paid';
export const StatusInvoiceEnum = {
    Invited: 'Paid' as StatusInvoiceEnum,
    Registered: 'Early Paid' as StatusInvoiceEnum
};
